import { useEffect, useState } from "react";

export default function CustomCursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    const move = (e) => setPos({ x: e.clientX, y: e.clientY });
    const over = (e) => {
      const t = e.target;
      if (t.closest("a, button, [role='button'], input, textarea, [data-cursor='hover']")) {
        setHovering(true);
      } else {
        setHovering(false);
      }
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, []);

  return (
    <div
      aria-hidden
      className="custom-cursor pointer-events-none fixed z-[9999] hidden md:block"
      style={{
        left: pos.x,
        top: pos.y,
        width: hovering ? 56 : 14,
        height: hovering ? 56 : 14,
        transform: "translate(-50%, -50%)",
        borderRadius: "9999px",
        background: hovering ? "transparent" : "#1C1C1E",
        border: hovering ? "1px solid #1C1C1E" : "none",
        mixBlendMode: "difference",
        transition: "width 0.25s ease, height 0.25s ease, background 0.2s ease",
      }}
    />
  );
}
